@if (showAdditionalRows()) {
  @if (price(); as mainPrice) {
    @if (priceAmount(); as priceAmount) {
      <div class="pricing-row">
        <div class="key">{{ mainPrice.product.name }}</div>
        <div class="value">{{ priceAmount / 100 | currency: 'USD' }}</div>
      </div>
    }
  }

  @if (additionalSeatsAmount(); as seatPriceAmount) {
    <div class="pricing-row">
      <div class="key">Additional seats</div>
      <div class="value">{{ seatPriceAmount / 100 | currency: 'USD' }}</div>
    </div>
  }
  @if (storageAmount(); as storageAmount) {
    <div class="pricing-row">
      <div class="key">Storage Addons</div>
      <div class="value">{{ storageAmount / 100 | currency: 'USD' }}</div>
    </div>
  }

  <div class="pricing-line"></div>
}

<div class="pricing-row">
  <div class="key">
    @if (trialMode() || updateTrialMode()) {
      Starting {{ trialEndDate() | date: 'MMM d' }}
    } @else {
      Total at Renewal
    }
  </div>
  <div class="value">
    @if (worstCaseAmount(); as worstCaseAmount) {
      @if (worstCaseAmount !== totalAmount()) {
        <div class="crossed-out">
          <span>{{ worstCaseAmount / 100 | customCurrency }}</span>
        </div>
      }
    }
    {{ totalAmount() / 100 | currency: 'USD' }}
  </div>
</div>

<div class="pricing-row">
  <div class="key due-today">
    Due Today

    @if (prorationMode() || balance()) {
      <app-context-menu [options]="{ width: '260px', openOnHover: true }" verticalPosition="top">
        <button
          appButton
          name="DONTREPORT"
          location="checkout-pricing-details"
          [iconButton]="true"
          height="-2"
          color="simple-gray"
          contextButton
        >
          <app-svg src="/assets/icons/16/info.svg" size="-1"></app-svg>
        </button>

        <div contextContent>
          @if (prorationMode()) {
            <app-checkout-proration-info [proration]="proration.value()"></app-checkout-proration-info>
          } @else {
            <div class="balance-info">
              You will use <b>{{ balanceToBeUsed() / 100 | customCurrency }}</b> of your existing balance. Your
              remaining balance will be <b>{{ remainingBalance() / 100 | customCurrency }}</b
              >.
            </div>
          }
        </div>
      </app-context-menu>
    }
  </div>
  <div class="value due-today">
    @if (dueTodayAmount() !== undefined) {
      {{ dueTodayAmount() / 100 | currency: 'USD' }}
    } @else {
      <app-loading-indicator size="small"></app-loading-indicator>
    }
  </div>
</div>
